const HisX = ({ color, sx }) => {
  const strokeColor = color ?? "#4C2AC6";
  const _sx = sx ?? {};

  return (
    <svg style={sx} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3125 6.03906L6.3125 18.0391"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.3125 6.03906L18.3125 18.0391"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisX;
